import apiService from '@/services/apiService';

const actions = {
  getMessage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('messaging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMessageDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('messaging/conversation', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getGeneralSettings({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get('messaging/setting/general/whatsapp', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delMessageDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.delete(`messaging/conversation?origin_phone=${payload.origin_phone}&customer_phone=${payload.customer_phone}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  sendMessage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('messaging/send', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  

};

export default actions;
